import React from 'react'
import { fanta, Link } from '@chegg/fanta'
import styled from 'styled-components'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

const { colors } = fanta

const TermsLink = styled(Link)`
  &&& {
    color: ${colors.grey};
    &:visited:hover:focus {
      color: ${colors.grey};
    }
    height: 12px;
    ${AspiraStack};
    font-size: 12px;
    letter-spacing: 0;
    line-height: 14px;
    font-weight: 400;
  }
`
export const LINK_COPY = '*See terms and conditions'

const TermsAndConditionsLink = ({ href, testId }) => (
  <TermsLink href={href} data-test={testId} target="_blank">
    {LINK_COPY}
  </TermsLink>
)

export default TermsAndConditionsLink
